<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.bank_info') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <!-- Linked card view -->
        <div v-if="is_bind" class="kb-card">
          <div class="kb-card__chip"></div>
          <div class="kb-card__brand">💳 KissMora Wallet</div>
          <div class="kb-card__name">{{ bankInfo.bankinfo }}</div>
          <div class="kb-card__row">
            <span class="kb-card__lbl">Holder</span>
            <span class="kb-card__val">{{ userInfo.name }}</span>
          </div>
          <div class="kb-card__row">
            <span class="kb-card__lbl">Account</span>
            <span class="kb-card__val">{{ maskedId }}</span>
          </div>
          <div class="kb-card__status">
            <span class="kb-card__dot"></span>
            <span>Linked</span>
          </div>
        </div>

        <!-- Empty state -->
        <button v-else class="kb-add" @click="toBindCard()">
          <div class="kb-add__ico">＋</div>
          <div class="kb-add__body">
            <strong>{{ $t('setting.add_bank') }}</strong>
            <small>Add a crypto wallet address for fast withdrawals.</small>
          </div>
          <span class="kb-add__chev">›</span>
        </button>

        <p class="kb-tip">💡 {{ $t('setting.bind_bank_tip') }}</p>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() { return { is_bind: false, bankInfo: {}, userInfo: {} }; },
  computed: {
    maskedId() {
      const id = String(this.bankInfo && this.bankInfo.bankid || '');
      if (!id) return '';
      if (id.length <= 4) return '•••• ' + id;
      return '•••• •••• ' + id.slice(-4);
    }
  },
  methods: {
    back() { return window.history.back(); },
    getUserBankInfo() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) { this.is_bind = true; this.bankInfo = res.data.info; }
          else { this.is_bind = false; }
        } else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) { this.userInfo = res.data; this.name = res.data.name; }
        else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else if (!this.userInfo.paypassword) {
        this.$router.push({ path: '/BindCard' });
        return true;
      } else {
        this.$router.push({ path: '/BindCard' });
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else { this.getUserInfo(); this.getUserBankInfo(); }
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";

.kb-card {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #1a1033 0%, #4a1a6e 50%, #ff4d8d 100%);
  color: #fff;
  border-radius: 18px;
  padding: 20px 22px;
  box-shadow: 0 14px 36px rgba(74,26,110,.3);
  min-height: 180px;
}
.kb-card::before {
  content: ''; position: absolute; inset: 0;
  background:
    radial-gradient(circle at 85% 0%, rgba(255,255,255,.15), transparent 40%),
    radial-gradient(circle at 10% 100%, rgba(160,32,240,.4), transparent 60%);
  pointer-events: none;
}
.kb-card__chip {
  width: 40px; height: 30px; border-radius: 6px;
  background: linear-gradient(135deg, #ffd700, #fbbf24);
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  margin-bottom: 14px; position: relative;
}
.kb-card__chip::after {
  content: ''; position: absolute; inset: 4px;
  border: 1px solid rgba(0,0,0,.2); border-radius: 3px;
}
.kb-card__brand { position: relative; font-size: 13px; font-weight: 700; opacity: .85; letter-spacing: .04em; margin-bottom: 4px; }
.kb-card__name {
  position: relative; font-size: 18px; font-weight: 800; letter-spacing: -.01em;
  margin-bottom: 12px; text-shadow: 0 2px 8px rgba(0,0,0,.3);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.kb-card__row {
  position: relative;
  display: flex; align-items: center; justify-content: space-between;
  font-size: 12px; padding: 4px 0; border-top: 1px solid rgba(255,255,255,.15);
}
.kb-card__lbl { opacity: .7; text-transform: uppercase; letter-spacing: .06em; }
.kb-card__val { font-weight: 700; font-family: 'SF Mono', ui-monospace, monospace; }
.kb-card__status {
  position: absolute; top: 16px; right: 16px;
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px; border-radius: 999px;
  background: rgba(16,185,129,.95); color: #fff;
  font-size: 10px; font-weight: 800; letter-spacing: .05em; text-transform: uppercase;
}
.kb-card__dot {
  width: 6px; height: 6px; border-radius: 50%; background: #fff;
  box-shadow: 0 0 0 3px rgba(255,255,255,.35);
  animation: kbPulse 1.4s ease-in-out infinite;
}
@keyframes kbPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.3); } }

.kb-add {
  display: flex; align-items: center; gap: 14px;
  width: 100%; padding: 20px; text-align: left;
  border-radius: 18px; cursor: pointer;
  background: linear-gradient(180deg, #fff 0%, #fff6fa 100%);
  border: 2px dashed rgba(255,77,141,.35);
  font-family: inherit; transition: background .2s, border-color .2s, transform .15s;
}
.kb-add:hover { border-color: #ff4d8d; transform: translateY(-2px); }
.kb-add__ico {
  width: 44px; height: 44px; border-radius: 14px;
  background: linear-gradient(135deg, #ff4d8d, #a020f0);
  color: #fff; font-size: 22px; font-weight: 300;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 18px rgba(255,77,141,.3);
}
.kb-add__body { flex: 1; }
.kb-add__body strong { display: block; font-size: 15px; font-weight: 800; color: #2a1a3f; margin-bottom: 2px; }
.kb-add__body small { font-size: 12px; color: #8273a0; line-height: 1.4; }
.kb-add__chev { color: #b8a9c9; font-size: 20px; }

.kb-tip {
  margin: 14px 4px 0;
  font-size: 12px; color: #8273a0; line-height: 1.5;
}
</style>
